import React, { useState } from 'react';
import UserServices from '../../services/UserServices.js';


const TogalButtonForBlockStatus = ({ data, page ,onSuccess}) => {
  
  const [isChecked, setIsChecked] = useState(data?.blockstatus === 'Block');

  // Handle checkbox toggle
  const handleToggle = async () => {
    const newStatus = !isChecked ? 'Block' : 'UnBlock'; 
    setIsChecked(!isChecked);
     
     if (page === 'user') {
      const res = await UserServices.updateUserblockStatus(data._id, {
        blockstatus: newStatus
      });
      onSuccess();
    }
    else if (page === 'vendor') {
      const res = await UserServices.updateVenderblockStatus(data._id, {
        blockstatus: newStatus
      });
      onSuccess();
    }
  };

  return (
   
      <div className="check-box">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
        />
      </div>
    
  );
};

export default TogalButtonForBlockStatus;
